import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedResumenComponent {
  idColaborador
  idProyecto
  data
  solicitudes
  informacion
  viaticoId
  onChange
  id_nomina = null
  permiteCerrar = false
  permiteSolicitar = false
  solicitarReembolso = false

  constructor ($state) {
    this.$state = $state
  }

  $onInit () {
    this.inicializar()
  }

  $onChanges (changes) {
    if (changes.solicitudes && !changes.solicitudes.isFirstChange()) {
      this.inicializar()
    }
  }

  agregarReembolso (data) {
    this.solicitarReembolso = false
    if (!data) return

    this.reembolsos = [...this.solicitudes.reembolsos, data]

    this.onChange({$event: {detail: this.reembolsos}})
  }

  cerrarViatico (status) {
    this.status = status
    this.cerrando = true
  }

  cerrar (cerrado) {
    this.cerrando = false

    if (cerrado === null) return

    this.permiteAbrir = cerrado
    this.permiteCerrar = !cerrado
    this.informacion.cerrado = cerrado
  }

  inicializar () {
    this.id_nomina = this.informacion.id_nomina
    let anticipos = this.solicitudes.anticipos.filter((item) => item.autorizado && item.pagado)
    let comprobaciones = this.solicitudes.comprobaciones.filter((item) => item.autorizado)
    let devoluciones = this.solicitudes.devoluciones.filter((item) => item.autorizado)
    let reembolsos = this.solicitudes.reembolsos.filter((item) => item.autorizado && item.pagado)

    this.permiteAbrir = this.informacion.rid
      && this.informacion.cerrado
      && !this.informacion.id_nomina
      && (comprobaciones.length ? !this.solicitudes.comprobaciones[0].id_nomina : true)

    this.permiteCerrar = this.informacion.acceso_solicitar
      && (this.informacion.fecha_limite.getTime()) - new Date() < 0
      && !this.informacion.cerrado

    this.permiteMaquilar = !this.solicitudes.comprobaciones.length
      && this.solicitudes.anticipos.length === anticipos.length
      && this.solicitudes.devoluciones.length === devoluciones.length
      && !this.informacion.id_nomina
      && this.informacion.acceso_solicitar
      && !this.informacion.eliminado

    this.permiteSolicitar = this.solicitudes.comprobaciones.every((comprobante) => comprobante.autorizado)
      && this.data.saldo > 1
      && this.solicitudes.reembolsos.length === reembolsos.length
      && this.informacion.acceso_solicitar
  }

  finalizar (data) {
    this.maquilando = false
    if (!data.nomina) return

    this.idProyecto = data.nomina.id_proyecto
    this.id_nomina = data.nomina.id_nomina
    if (data.redireccionar) {
      this.redireccionarNomina()
    }
  }

  redireccionarNomina () {
    this.$state.go('nominas.detalladoNomina.colaboradores', {idEmpresa: this.idProyecto, idNomina: this.id_nomina})
  }
}

module.component('viaticosSharedResumen', {
  controller: ViaticosSharedResumenComponent,
  template,
  bindings: {
    idColaborador: '<',
    idProyecto: '<',
    data: '<',
    solicitudes: '<',
    informacion: '<',
    viaticoId: '<',
    responsableMaquilar: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/resumen/component.js